<template>
<modal name="warning" height="auto" :width="480" :pivotX="0" :pivotY=".15" @before-open="assignParams">

  <aside class="window warning-message">
    <header class="window__header">
      <h1 class="window__title">Are you sure?</h1>
      <p class="window__description">
        {{ messageText }}
      </p>
    </header>

    <footer class="window__footer">
      <span class="window__button button button--remove button--large" v-on:click="confirm">{{ buttonText }}</span>
      <span class="window__link link link--secondary" v-on:click="hide">Cancel</span>
    </footer>
  </aside>

</modal>
</template>

<script>
export default {
  name: 'Warning',
  methods: {
    assignParams (event) {
      this.callback = event.params.callback
      this.messageText = event.params.messageText
      this.buttonText = event.params.buttonText
    },
    hide () {
      this.$modal.hide('warning')
    },
    confirm () {
      this.$modal.hide('warning')
      this.callback()
    }
  },

  data () {
    return {
      messageText: null,
      buttonText: null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modals/Warning.vue